import { CreateAnimation, IonAvatar, IonCard, IonCardContent, IonCol, IonIcon, IonImg, IonLabel, IonRow, IonText } from '@ionic/react'
import './Donation.css'

interface Props {
    avatar: string,
    title: string,
    date: string,
    price: string,
    text?: string,
    link?: string | null
}

const Donation: React.FC<Props> = (props) => {
    return (
        <IonCard routerLink={props.link!} className="donation-item">
            <IonCardContent>
                <IonRow>
                    <IonCol size="2">
                        <IonAvatar>
                            <IonImg src={props.avatar} />
                        </IonAvatar>
                    </IonCol>
                    <IonCol size="10">
                        <IonLabel className="title ion-float-right">{props.title}</IonLabel>
                        <IonLabel className="date ion-float-left">{props.date}</IonLabel>
                        <IonText className="price">{props.price}</IonText>
                    </IonCol>
                </IonRow>
                {props.text!!.length > 0 ?
                    <IonRow className="text-container">
                        <IonCol>
                            <IonText className="text"><div dangerouslySetInnerHTML={{ __html: props.text!! }}></div></IonText>
                        </IonCol>
                    </IonRow> : null}
            </IonCardContent>
        </IonCard>
    )
}

export default Donation